import { cn } from "@/libs/cn";
import { Button } from "antd";
import { AiOutlineClose } from "react-icons/ai";
import { PostImage } from ".";

export function AddedImagesPreview({
    images,
    onRemoveImage
}: {
    images: PostImage[];
    onRemoveImage: (image: PostImage) => void;
}) {
    return (
        <div
            className={cn("grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4", {
                "grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2": images.length === 2,
                "grid-cols-1 lg:grid-cols-1 sm:grid-cols-1 ": images.length === 1
            })}
        >
            {
                images.map((it) => (
                    <div
                        key={JSON.stringify(it)}
                        className="relative flex items-center justify-center rounded-md bg-black/50 overflow-hidden aspect-video"
                    >
                        <img
                            src={it.imgUrl as string}
                            alt="Post image"
                            className=" object-contain w-full h-full "
                        />
                        <Button
                            className={"!absolute top-2 right-2 !p-0 !aspect-square !bg-black/30 hover:!bg-black/60 transition duration-200 !text-white"}
                            size="small"
                            onClick={() => onRemoveImage(it)}
                            type="text"
                            shape="circle"
                        >
                            <AiOutlineClose />
                        </Button>
                    </div>
                ))
            }
        </div>
    )
}
